import { render, staticRenderFns } from "./AffiliationCheckout.vue?vue&type=template&id=4c72ba2e&scoped=true"
import script from "./AffiliationCheckout.vue?vue&type=script&lang=js"
export * from "./AffiliationCheckout.vue?vue&type=script&lang=js"
import style0 from "./AffiliationCheckout.vue?vue&type=style&index=0&id=4c72ba2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72ba2e",
  null
  
)

export default component.exports